import { useEffect, useState } from 'react';

export const usePreLoader = () => {
  const [isPreLoading, setIsPreloading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsPreloading(false);
    }, 2000);
  }, [])

  return [isPreLoading, setIsPreloading];
};
